































import Vue from 'vue';
import {RouterAliases} from '@/router/routerAliases';
import IconLogout from '../svg/logout.vue';
import {logout} from '@/services/auth-shared';
import SecondaryMenu from './secondary-menu.vue';
import {useRouter} from '@/router';

const SCROLL_THRESHOLD = 120;

export interface NavItem {
  name: string;
  route: string;
}

export default Vue.extend({
  name: 'MainMenu',
  components: {
    IconLogout,
    SecondaryMenu,
  },
  props: {
    pageTitle: {
      type: String,
      default: '',
    },
    navItems: {
      type: Array,
      default: [] as NavItem[],
    },
  },
  data(): {scrollContainer: Element | null; isScrolledDown: boolean} {
    return {
      scrollContainer: null as Element | null,
      isScrolledDown: false,
    };
  },
  mounted(): void {
    this.scrollContainer = window.document.querySelector('.content-wrapper');
    if (this.scrollContainer) {
      (this.scrollContainer as Element).addEventListener('scroll', this.onScroll);
    }
  },
  beforeDestroy(): void {
    if (this.scrollContainer) {
      (this.scrollContainer as Element)?.removeEventListener('scroll', this.onScroll);
    }
  },
  computed: {
    classList(): object {
      return {
        'scrolled-down': this.isScrolledDown,
      };
    },
    discoverRoute(): {name: string} {
      return {name: RouterAliases.DISCOVERY_VIEW};
    },
    myTripsRoute(): {name: string} {
      return {name: RouterAliases.MY_TRIPS_VIEW};
    },
    isAmexAuth(): boolean {
      return !!process.env.VUE_APP_AMEX_AUTH_ENABLED;
    },
    logoUrl(): string {
      return process.env.VUE_APP_MENU_LOGO || '/img/amex-logo.svg';
    },
    logoAltText(): string {
      return process.env.VUE_APP_TITLE || 'Mobi Agent Trip Planner';
    },
  },
  methods: {
    logout(): void {
      logout();
      const router = useRouter();
      router.replace({name: RouterAliases.AMEX_LANDING});
    },
    onScroll(): void {
      const scrollPosition = (this.scrollContainer as Element).scrollTop;

      if (scrollPosition > SCROLL_THRESHOLD) {
        this.isScrolledDown = true;
      } else {
        this.isScrolledDown = false;
      }
    },
  },
});
